import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { Router } from 'react-router';

import { saveCurrentRoute as saveCurrentRouteAC } from 'actions/routes';
import { scrollTo as scrollToAC } from 'actions/window';
import routes from 'routes';


class Root extends Component {
  constructor(props) {
    super(props);
    this.removeHistoryListener = () => {};
  }

  componentDidMount() {
    this.removeHistoryListener = this.listenForRouteChange();
  }

  componentWillUnmount() {
    this.removeHistoryListener();
  }

  listenForRouteChange() {
    const { history, saveCurrentRoute, scrollTo } = this.props;
    // history returns a function that unsubscribes the listener later
    return history.listen(location => {
      saveCurrentRoute(location.pathname);
      scrollTo(0, 0);
    });
  }

  render() {
    const { store, history } = this.props;

    return (
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  saveCurrentRoute: PropTypes.func.isRequired,
  scrollTo: PropTypes.func.isRequired,
};

export default connect(null, {
  saveCurrentRoute: saveCurrentRouteAC,
  scrollTo: scrollToAC,
})(Root);



// WEBPACK FOOTER //
// ./src/containers/Root.js